import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.use(ElementUI, { size: 'small' })
Vue.config.productionTip = false

// 全局图片URL处理：纯文件名自动拼接 /uploads/ 前缀
Vue.prototype.$imgUrl = function(path) {
  if (!path) return ''
  if (path.startsWith('http://') || path.startsWith('https://')) return path
  if (path.startsWith('/')) return path
  return '/uploads/' + path
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
